import { useEffect, useRef } from "react";
import { Container, Nav, Navbar } from "react-bootstrap";
import classNames from "classnames";
import { Link, NavLink } from "react-router-dom";

// images
import logo from "../../assets/TINT.png";
import logoLight from "../../assets/logo-light.png";

const NavbarComponent = ({
  isSticky,
  navClass,
  buttonClass,
  fixedWidth,
  hideSearch,
}) => {
  const navbarRef = useRef(null);
  const collapseRef = useRef(null);

  // Handle click outside to close mobile menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      // Only handle on mobile screens
      if (window.innerWidth > 991.98) return;

      const navbar = navbarRef.current;
      const collapse = collapseRef.current;
      
      if (!navbar || !collapse) return;

      // Check if collapse is shown
      const isCollapseShown = collapse.classList.contains('show');
      
      if (isCollapseShown) {
        // Check if click is outside navbar
        if (!navbar.contains(event.target)) {
          // Close the collapse by clicking the toggle button
          const toggleButton = navbar.querySelector('[aria-controls="topnav-menu-content"]');
          if (toggleButton && !toggleButton.contains(event.target)) {
            toggleButton.click();
          }
        }
      }
    };

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    // Cleanup
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, []);

  // Add navbar-sticky class on scroll
  useEffect(() => {
    const btnTop = document.getElementById("btn-back-to-top");
    const navbar = document.getElementById("sticky");
    window.addEventListener("scroll", (e) => {
      e.preventDefault();
      if (btnTop) {
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          btnTop.classList.add("show");
        } else {
          btnTop.classList.remove("show");
        }
      }
      if (navbar) {
        if (
          document.body.scrollTop >= 240 ||
          document.documentElement.scrollTop >= 240
        ) {
          navbar.classList.add("navbar-sticky");
        } else {
          navbar.classList.remove("navbar-sticky");
        }
      }
    });
  }, []);

  return (
    <>
      <style>{`
        @media (max-width: 991.98px) {
          .mobile-auth-nav {
            border-top: 1px solid rgba(0, 0, 0, 0.1);
            margin-top: 0.5rem;
            padding-top: 0.75rem;
            padding-bottom: 0.75rem;
            background-color: #ffffff;
          }
          .mobile-auth-nav .nav {
            width: 100%;
            flex-direction: column;
            gap: 1rem;
          }
          .mobile-auth-nav .nav-item {
            width: 100%;
            margin: 0 !important;
          }
          .mobile-auth-nav .auth-nav-link {
            display: block;
            width: 100%;
            padding: 0.75rem 1.25rem !important;
            text-align: center;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 6px;
            transition: all 0.2s ease;
            font-size: 1rem !important;
          }
          .mobile-auth-nav .auth-nav-link:hover {
            background-color: rgba(0, 0, 0, 0.02);
            border-color: rgba(0, 0, 0, 0.15);
          }
          .mobile-auth-nav .auth-join-btn {
            display: block;
            width: 100%;
            padding: 0.75rem 1.25rem !important;
            text-align: center;
            font-size: 1rem !important;
            font-weight: 600;
            border-radius: 6px;
          }
        }
      `}</style>
      <header>
        <Navbar
          ref={navbarRef}
          id={isSticky ? "sticky" : ""}
          collapseOnSelect
          expand="lg"
          className={classNames("topnav-menu", navClass)}
        >
        <Container fluid={!fixedWidth}>
          {/* Align logo to the left */}
          <Navbar.Brand as={Link} to="/" className="logo">
            <img
              src={logo}
              height="28"
              width="auto"
              style={{ maxHeight: "28px", maxWidth: "110px", objectFit: "contain" }}
              className="align-top logo-dark"
              alt="Logo"
            />
            <img
              src={logoLight}
              height="28"
              width="auto"
              style={{ maxHeight: "28px", maxWidth: "110px", objectFit: "contain" }}
              className="align-top logo-light"
              alt="Logo Light"
            />
          </Navbar.Brand>

          {/* Custom Toggle Button */}
          <Navbar.Toggle
            aria-controls="topnav-menu-content"
            className="border-0 shadow-none mobile-nav-toggle"
            style={{
              border: '1px solid rgba(0, 0, 0, 0.1)',
              borderRadius: '4px',
              padding: '0.5rem 0.75rem'
            }}
          >
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>

          <Navbar.Collapse ref={collapseRef} id="topnav-menu-content" className="mobile-auth-nav">
            <Nav className="ms-auto align-items-lg-center">
              {!hideSearch && (
                <Nav.Item as="li" className="d-none d-lg-flex">
                  <form id="search" className="form-inline">
                    <div className="form-control-with-hint ms-lg-2 ms-xl-4">
                      <input
                        type="text"
                        className="form-control"
                        id="search-input"
                        placeholder="What are you looking for?"
                      />
                      <span className="form-control-feedback uil uil-search fs-16"></span>
                    </div>
                  </form>
                </Nav.Item>
              )}

              <Nav.Item as="li" className="me-3">
                <NavLink
                  to="/signin"
                  end
                  className="nav-link text-dark auth-nav-link"
                  style={{ fontWeight: "bold", fontSize: "1rem" }}
                >
                  <span>Login</span>
                </NavLink>
              </Nav.Item>
              <Nav.Item as="li">
                <Link
                  to="/signup"
                  className={classNames("btn", buttonClass, "btn-primary", "auth-join-btn")}
                  style={{ fontSize: "1rem" }}
                >
                  Join Now
                </Link>
              </Nav.Item>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </header>
    </>
  );
};

export default NavbarComponent;
